import InteractionIntervalSetting from "../../../../models/communications/InteractionIntervalSetting";
import InteractionIntervalSubscribeButton from "./widgets/InteractionIntervalSubscribeButton";
import InteractionIntervalCommunicationsButton from "./widgets/InteractionIntervalCommunicationsButton";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { CSSProperties, useState } from "react";
import "./styles/MatrixControls.css";

const MatrixCellControlsBox = (props: InteractionIntervalSetting) => {
  const [style, setStyle] = useState<CSSProperties>({ display: "none" });
  return (
    <Box
      data-testid={"matrixControlCell"}
      sx={{ flexGrow: 1 }}
      style={{ padding: "0px", margin: "0px" }}
      onMouseEnter={(e) => {
        setStyle({
          display: "inline-block",
          padding: "0px",
          margin: "0px",
          position: "absolute",
        });
      }}
      onMouseLeave={(e) => {
        setStyle({ display: "none" });
      }}
    >
      <Grid container spacing={2} style={{ textAlign: "center" }}>
        <Grid item xs={12} style={{ padding: "0px", margin: "0px" }}>
          <InteractionIntervalSubscribeButton {...props} />
          {/*
          <div className={"elementToFadeInAndOut"} style={style}>
            <InteractionIntervalCommunicationsButton {...props} />
          </div>
          */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default MatrixCellControlsBox;
